import Typeahead from "./typeahead"

export default Typeahead
